import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getMeasurementTableBlockConfig } from '../services/config/function';
import { measurementTableConfigKeys } from '../services/config/key';
import { NumericTable } from '../components/NumericTable';
import { measurementKeys } from '../services/measurement/key';
import '../styles/main.css';
import './Measurement.css';

function Measurement() {
  const { status : status, data : data, error: error } = useQuery({
    queryKey: measurementTableConfigKeys.all,
    queryFn: getMeasurementTableBlockConfig,
    staleTime: Infinity,
    meta: { numBlocks : 100, numParams : 10 },
  })

  // event handler 
  const queryClient = useQueryClient();
  const handleTestButtonClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    queryClient.invalidateQueries({queryKey: measurementKeys.all});
    event.preventDefault();
    return false;
  }

  // if (isPending) 
  if (status === 'pending') {
    return <span>Loading...</span>
  }

  // if (isError) 
  if (status === 'error') {
    return <span>Error: {error.message}</span>
  }

  return (
    <>
      { 
        (() => {
          console.log('measurement page is now rendering...');
          return null;
        })() && undefined
      }
      <h2>Measurement Report Test Page</h2>
      <section className="button-section">
        <a href="#" 
         className="push_btn"
         onClick={handleTestButtonClick}>
          Test[Full value change]
        </a>
      </section>
      <section>
        {data?.map((cfg) => (
          <NumericTable props={cfg} key={cfg.blockName}/>
          //<NumericTable key={cfg.blockName}/>
        ))}
        <p className="read-the-docs">
          Footer part.
        </p>
      </section>
    </>
  )
}

export default Measurement
